module.exports = __webpack_public_path__ + "img/eye-slash.b041e441.svg";